import _isFunction from "lodash/isFunction";
import compileRequest from './compileRequest';
import fetch from 'isomorphic-fetch';
import HTTPError from '../errors/HTTPError';
import logError from './logError';
import parseResponse from './parseResponse';
import Promise from 'bluebird';
import redirectOnForbidden from './redirectOnForbidden';
import redirectOnUnauthorized from './redirectOnUnauthorized';
import handleTooManyRequests from './handleTooManyRequests';
import throwOnError from './throwOnError';
/**
 * Send HTTP request
 *
 * @param  {Object} state - application state
 * @param  {String} path - path to API method
 * @param  {String} [method = 'get'] - HTTP method
 * @param  {Object} [query = {}] - query params
 * @param  {Object} [body = null] - request body
 * @param  {Object} [headers = {}] request headers
 * @param  {Boolean} [redirect = true] - redirect on unauthorized error
 * @param  {Function} [parser = parseResponse] - request parse function
 * @param  {Function} [errorsHandler] - custom handler for WebAPI errors
 * @return {Promise} - promise
 */

export default function sendRequest(_ref) {
  var state = _ref.state,
    path = _ref.path,
    _ref$method = _ref.method,
    method = _ref$method === void 0 ? 'get' : _ref$method,
    _ref$query = _ref.query,
    query = _ref$query === void 0 ? {} : _ref$query,
    _ref$body = _ref.body,
    body = _ref$body === void 0 ? null : _ref$body,
    _ref$headers = _ref.headers,
    headers = _ref$headers === void 0 ? {} : _ref$headers,
    _ref$redirect = _ref.redirect,
    redirect = _ref$redirect === void 0 ? true : _ref$redirect,
    _ref$parser = _ref.parser,
    parser = _ref$parser === void 0 ? parseResponse : _ref$parser,
    errorsHandler = _ref.errorsHandler;
  var _compileRequest = compileRequest({
      state: state,
      path: path,
      method: method,
      query: query,
      body: body,
      headers: headers
    }),
    url = _compileRequest.url,
    options = _compileRequest.options;
  var fetchPromise = fetch(url, options);
  /**
   * Invokes custom errors handler, if presented, and breaks the chain
   * for `redirectOnUnauthorized` and `redirectOnForbidden` logic not to be handled
   *
   * @param  {Error} error — WebAPI error
   * @return {Error} — thrown error
   */

  function handleError(error) {
    if (_isFunction(errorsHandler)) {
      errorsHandler(error, redirect);
      throw new HTTPError(error);
    }
    throw error;
  }
  return Promise.resolve(fetchPromise).catch(logError).then(throwOnError).catch(handleError).catch(redirect ? redirectOnUnauthorized : function (error) {
    throw error;
  }).catch(redirect ? redirectOnForbidden : function (error) {
    throw error;
  }).catch(handleTooManyRequests).then(parser);
}